export default __webpack_public_path__ + "img/1_6-88d7cc5f.png";